// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"353":"contact","594":"about","623":"case-detail","671":"services","794":"cases"}[chunkId] + "." + {"353":"65608bf5","594":"8f033803","623":"10e60c89","671":"bbdad8cd","794":"7098e14d"}[chunkId] + ".js";
};